import React, { Component } from "react";

import HLSPlayer from "./Vanilla";
import THEOplayer from "./THEOplayer";
import NexPlayer from "./NexPlayer";
import BitmovinPlayer from "./Bitmovin";

export const PlayerVanilla = "vanilla";
export const PlayerTheoplayer = "theo";
export const PlayerNexPlayer = "nex";
export const PlayerBitmovin = "bitmovin";

export default class VideoPlayerSelector extends Component {
  shouldComponentUpdate(nextProps) {
    return nextProps.playerKind !== this.props.playerKind;
  }

  render() {
    const { playerKind, ...other } = this.props;

    switch (this.props.playerKind) {
      case PlayerTheoplayer:
        return <THEOplayer {...other} />;
      case PlayerNexPlayer:
        return <NexPlayer {...other} />;
      case PlayerBitmovin:
        return <BitmovinPlayer {...other} />;

      default:
        return <HLSPlayer {...other} />;
    }
  }
}



// WEBPACK FOOTER //
// ./src/VOD/Players/Selector.js